import React from 'react';

import Chip from '~/components/core/Atomic/Chip/Chip';

// Says where a field or configuration came from (CONFIGURED, CUSTOM): a pale teal chip, its border a lighter shade
// of its text.
type ClaimBarPillProps = {
  label: string;
};

const ClaimBarPill = ({ label }: ClaimBarPillProps) => (
  <Chip
    label={label}
    size="small"
    variant="outlined"
    className="m-0 border-teal-300 bg-teal-100 font-medium uppercase text-teal-800"
  />
);

export default ClaimBarPill;
